import React from 'react';
import './AccountsContent.css';

function AccountsContent() {
  return (
    <>
        <h1 className='comming-soon'>Coming Soon</h1>
    </>
  )
}

export default AccountsContent